import {toRef} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"

//響應機制的userinfo
const userInfoRef = toRef(useUserinfo())

const cardApi = {
    //获取部门和名片
    "queryDepartMemberwork": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/work/queryDepartMemberwork`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: userInfoRef.value.companycode,
                department: null,
                id: userInfoRef.value.id,
                login: userInfoRef.value.login
            }
        }
    },
    //获取通讯录
    "queryAddressBookCardList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/record1/queryAddressBookCardList`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                additionalRecord1: {
                    addinfo1: null,
                    login: null,
                    updatedid: -1
                },
                keyword: null,
                pageNum: 1,
                pageSize: 255
            }
        }
    },
    //添加通訊錄
    "insertAdditionalrecord9": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/record9/insertAdditionalrecord9`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo1: null,
                addinfo2: null,
                addinfo3: null,
                addinfo4: null,
                companycode: null,
                login: null
            }
        }
    },
    //刪除通訊錄
    "delAdditionalrecord9": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/record9/delAdditionalrecord9`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null
            }
        }
    },
    //發送邀請通訊錄人員email
    "sendNewEmailByAddinfo9": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/work/sendNewEmailByAddinfo9`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                memberworkId: null,
                companyname: null,
                name: null
            }
        }
    },
    //通過用戶id查詢用戶最新名片
    "queryNewestMemberWorkById": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/work/queryNewestMemberWorkById`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                defaulttag: 0
            }
        }
    },
    //刪除收錄名片
    "delRecord1": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/record1/delRecord1`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null
            }
        }
    },
    //使用名片id查找名片
    "queryMemberWorkById": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/work/queryMemberWorkById`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null
            }
        }
    },
    //使用名片id查找不含代码的名片
    "querySimpleMemberWorkById": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/work/querySimpleMemberWorkById`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null
            }
        }
    },
    //發送分享郵件
    "sendMemberworkShareEmail": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/Share/sendMemberworkShareEmail`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                email: null,
                url: null,
                content: null,
                userId: null,
                img: null
            }
        }
    },
    //修改名片
    "update": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}work/update`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {}
        }
    },
    //查詢公司默認名片
    "queryCompanyDefaultMemberWork": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}work/queryCompanyDefaultMemberWork`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null
            }
        }
    },
    //通过聊天id列表查询名片信息
    "queryMemberworkByAddinfo2List": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}work/queryMemberworkByAddinfo2List`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                stringList: null  //用户id数组
            }
        }
    },
    //获取单个名片
    "querySingleMemberwork": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}work/querySingleMemberwork`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                login: null
            }
        }
    },
    //通過名片查詢公司信息
    "queryCompanyByMemberwork": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}work/queryCompanyByMemberwork`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                id: null, //名片id
            }
        }
    },
    //查詢企業名片模板(如果沒有會新增)
    "queryCompanyDefaultMemberWorkId": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}work/queryCompanyDefaultMemberWorkId`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                login: null,
            }
        }
    },
    //分部門查詢名片
    "queryDepartCardList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}work/queryDepartCardList`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                login: null,
                id: null,
                department: null
            }
        }
    },
    //通過eshopopee公司代碼和域名查詢名片模板
    "queryMemberWorkByAcccode": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}work/queryMemberWorkByAcccode`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                acccompanycode: null,
                currentcapital: null,
            }
        }
    },
    //查詢展館圖片
    "queryByHall": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}work/queryByHall`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                telephone: null,  //關鍵字
                updatedid: null,  //展館id
            }
        }
    },
    //查詢
    "queryMemberworkAll": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}work/queryMemberworkAll`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {

            }
        }
    }
}

export default cardApi